import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ProcessLoader } from '@/common/components';
import { COMMON_TRANSLATION } from '@/common/constants';

import { StyledContainer } from './LoggingOut.styles';

const LoggingOut: FC = () => {
  const { t } = useTranslation(COMMON_TRANSLATION);

  return (
    <StyledContainer>
      <ProcessLoader title={t('logging_out')} />
    </StyledContainer>
  );
};

export default LoggingOut;
